<div class="title">
    <span>{{ 'translation:Delete' | i18next }}</span>
</div>
<div class="dialog-content">
    <div class="text-container">
        {{ 'translation:Delete category' | i18next }}
    </div>
</div>
<mat-dialog-actions>
    <button matButton [ngClass]="['secondary-button']" (click)="closeDialog()">{{ 'translation:Cancel' | i18next }}</button>
    <button matButton [ngClass]="['primary-button', 'delete-button-dialog']" (click)="deleteCategory()">{{ 'translation:Delete' | i18next }}</button>
</mat-dialog-actions>